import React, { Component } from "react";
import styled from "styled-components";
import { graphql } from "react-apollo";
import { observer } from "mobx-react";
import { mutationUpdatePendingStream } from "Apollo";
import {
  CaseManagementStore,
  CommonStore,
  ResetMessage,
  ShowNotice
} from "Store";
import ChannelLimit from "./ChannelLimit";
import Input from "./Input";

export default graphql(mutationUpdatePendingStream)(
  observer(
    class ApprovalFooter extends Component {
      render() {
        const selected = CaseManagementStore.selectedCase;
        if (selected) {
          const signature = CommonStore.me.agent.shortName;
          const content = CaseManagementStore.editPending.content;
          const channel = selected.channel;
          const channelType = CaseManagementStore.channelType;
          const limit = channelType.limit - content.length;
          return (
            <Wrapper>
              <Input
                value={content}
                onChange={text => {
                  CaseManagementStore.editPending.content = text;
                }}
                onKeyPress={this.onInputEnter}
              />
              <Bottom>
                <ChannelLimit channel={channel.name} limit={limit} />
                <Signature>-{signature}</Signature>
                <CancelButton onClick={this.onCancel}>Cancel</CancelButton>
                <ApproveButton onClick={this.onSend}>Resend</ApproveButton>
              </Bottom>
            </Wrapper>
          );
        }
      }

      onInputEnter = event => {
        if (event.key === "Enter") {
          this.onSend();
          event.preventDefault();
        }
      };

      onCancel = () => {
        CaseManagementStore.editPending = { id: -1, conten: "" };
      };

      onSend = () => {
        // dont send if over text limit
        const content = CaseManagementStore.editPending.content;
        const limit = CaseManagementStore.channelType.limit - content.length;
        if (limit < 0) return;

        const id = CaseManagementStore.editPending.id;
        ResetMessage();

        try {
          this.props.mutate({
            variables: {
              pendingStream: { id: id },
              contentOpt: content
            }
          });
          ShowNotice("pending-update-success");
        } catch (error) {
          ShowNotice("pending-update-error");
        }
      };
    }
  )
);

const Wrapper = styled.div`
  display: flex;
  flex: none;
  flex-direction: column;
`;
const Bottom = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 50px;
  padding: 0 16px;
`;
const Signature = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.uiText};
  margin-left: 4px;
  margin-right: auto;
`;
const CancelButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  color: ${props => props.theme.uiText};
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.9rem;
  background-color: transparent;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;

const ApproveButton = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  color: ${props => props.theme.blueButton};
  transition: 0.3s;
  cursor: pointer;
  font-size: 0.9rem;
  background-color: transparent;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;



// WEBPACK FOOTER //
// ./src/module-case-management/content-panel/footer/ApprovalFooterWithStoreMutation.js